export type PathParams = {
  lang: string
}

export type MediaProps = {
  type: MediaLightboxType
  src: string
  title?: string
  provider?: MediaLightboxProvider
  className?: string
}

export enum MediaLightboxType {
  IMAGE = 'IMAGE',
  VIDEO = 'VIDEO',
  IFRAME = 'IFRAME'
}

export enum MediaLightboxProvider {
  YOUTUBE = 'YOUTUBE',
  VIMEO = 'VIMEO',
  HOTMART = 'HOTMART'
}
